import {
  ChangeDetectionStrategy,
  Component,
  input,
  linkedSignal,
  output,
} from '@angular/core';

export interface duoSelectorToggleData {
  leftButton: { text: string; value: string };
  rightButton: { text: string; value: string };
  labelText?: string;
}
@Component({
  selector: 'ss-duo-selector-toggle',
  imports: [],
  templateUrl: './duo-selector-toggle.component.html',
  styleUrl: './duo-selector-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DuoSelectorToggleComponent {
  data = input.required<duoSelectorToggleData>();
  defaultValue = input<string>('');
  valueChange = output<string>();
  selectedValue = linkedSignal(
    () => this.defaultValue() || this.data().leftButton.value
  );

  toggleSelectedValue(value: string): void {
    this.selectedValue.set(value);
    this.valueChange.emit(value);
  }
}
